export function throttle<T extends (...args: any[]) => void>(func: T, threshhold: number = 250, scope?: any): T {
    let last: number, deferTimer: number;
    return function (this: any) {
        const context = scope || this;

        const now = Date.now();
        const args = Array.from(arguments);
        if(last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = window.setTimeout(function () {
                last = now;
                func.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            func.apply(context, args);
        }
    } as T;
}
